import { useEffect } from 'react';
import { useQuery } from 'convex/react';
import { api } from '@/convex/_generated/api';
import { useCurrentContext } from '@/hooks/useCurrentContext';
import { useTaskStore } from '@/stores/taskStore';

export function TaskStoreProvider({ children }: { children: React.ReactNode }) {
  const { contextId } = useCurrentContext();
  const setAllTasks = useTaskStore((state) => state.setAllTasks);
  
  // Query all active tasks from Convex
  const allTasks = useQuery(
    api.normalTasks.queries.getAllActiveTasks,
    contextId ? { contextId } : 'skip'
  );
  
  // Sync Convex data with Zustand store
  useEffect(() => {
    setAllTasks(allTasks);
  }, [allTasks, setAllTasks]);
  
  return <>{children}</>;
}